<template>
    <button type="button" class="unit-bubble" :style="{ borderColor: color }" @click="$emit('click')">
        <div class="unit-bubble-avatars">
            <v-avatar v-for="user in visibleUsers" :key="user.id" size="35" class="unit-bubble-avatar">
                <v-img v-if="user.profile_picture" :src="getProfilePictureUrl(user.profile_picture)"></v-img>
                <v-avatar v-else color="primary" size="35" class="white--text" style="font-size: 0.55rem">{{ initials(user) }}</v-avatar>
            </v-avatar>
            <div v-if="remoteUsers.length > maxAvatars" class="unit-bubble-more">+{{ remoteUsers.length - maxAvatars }}</div>
        </div>
        <div class="unit-bubble-name">{{ unit }}</div>
        <div class="unit-bubble-count">{{ remoteUsers.length }} remote</div>
    </button>
</template>

<script>
export default {
    name: 'UnitBubble',
    props: {
        unit: { type: String, required: true },
        color: { type: String, default: '#9e9e9e' },
        remoteUsers: { type: Array, default: () => [] },
    },
    data() {
        return {
            maxAvatars: 4,
        };
    },
    computed: {
        apiUrl() {
            return process.env.VUE_APP_API_URL || '';
        },
        visibleUsers() {
            return this.remoteUsers.slice(0, this.maxAvatars).map((ru) => ru.user);
        },
    },
    methods: {
        initials(user) {
            if (!user || !user.name) return '?';
            const names = user.name.split(' ');
            return names.length >= 2 ? (names[0][0] + names[1][0]).toUpperCase() : user.name.substring(0, 2).toUpperCase();
        },
        getProfilePictureUrl(path) {
            if (!path) return '';
            if (path.startsWith('http://') || path.startsWith('https://')) return path;
            return `${this.apiUrl}/${path}`;
        },
    },
};
</script>

<style scoped>
.unit-bubble {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: 150px;
    background: #ffffff;
    border: 2px solid #9e9e9e;
    border-radius: 14px;
    padding: 8px 6px;
    cursor: pointer;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.unit-bubble:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
}

.unit-bubble-avatars {
    display: flex;
    align-items: center;
}

.unit-bubble-avatar {
    margin-left: -8px;
    border: 2px solid #ffffff;
}

.unit-bubble-avatar:first-child {
    margin-left: 0;
}

.unit-bubble-more {
    margin-left: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #eeeeee;
    border: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.55rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
}

.unit-bubble-name {
    font-size: 0.7rem;
    font-weight: 700;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.unit-bubble-count {
    font-size: 0.6rem;
    color: rgba(0, 0, 0, 0.5);
}
</style>
